import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Wrapper } from "@/modules/landings/protection/components/TrackingNumber";
import { Table } from "antd";
import dayjs from "dayjs";
import React from "react";
export const TrackingResult = (param)=>{
    let { data  } = param;
    var _dayjs, _data_;
    const expiredAt = (_dayjs = dayjs((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.expired_at)) === null || _dayjs === void 0 ? void 0 : _dayjs.format("YYYY.MM.DD");
    const columns = [
        {
            title: "R인증 번호",
            dataIndex: "r_number",
            key: "r_number"
        },
        {
            title: "수업자료명",
            dataIndex: "book_name",
            key: "book_name"
        },
        {
            title: "저작자명",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "만료일",
            key: "expired_at",
            dataIndex: "expired_at",
            render: (date)=>{
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: data[0].is_expired && "red"
                    },
                    children: data[0].is_expired ? "".concat(expiredAt, "만료됨") : expiredAt
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "title",
                children: "조회결과"
            }),
            /*#__PURE__*/ _jsx(Table, {
                columns: columns,
                dataSource: data,
                locale: {
                    emptyText: "조회된 결과가 없습니다."
                },
                pagination: false
            })
        ]
    });
};
